import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingPageService } from '@umss/shared/ui';

export const enum CorporateTabDetailEntity {
  Facility = 'Facility',
  Admin = 'Admin',
  Invoice = 'Invoice',
  Notification = 'Notification'
}

@Injectable({
  providedIn: 'root'
})
export class CorporateTabTitleService {
  private readonly appName = 'HURO';

  private readonly title = inject(Title);
  private readonly loadingPageService = inject(LoadingPageService);
  constructor() {
    // Listen to loading state changes to update the title accordingly
    this.loadingPageService.navigationEnd$.subscribe((url) => {
      this.setForUrl(url);
    });
    this.setForUrl(window.location.pathname);
  }

  setForUrl(rawUrl: string): void {
    const url = this.normalizeUrl(rawUrl);
    this.setDocumentTitle(this.resolveFallbackTitle(url));
  }

  setDetailTitle(
    entity: CorporateTabDetailEntity | `${CorporateTabDetailEntity}`,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload?: any
  ): void {
    switch (entity) {
      case 'Facility':
        return this.setDocumentTitle(
          `Facility · ${payload?.name || 'Details'}`
        );
      case 'Admin':
        return this.setDocumentTitle(
          `Admin · ${payload?.firstName || ''} ${payload?.lastName || ''}`.trim() ||
            'Details'
        );
      case 'Invoice':
        return this.setDocumentTitle(
          `Invoice · ${payload?.invoiceNumber || 'Details'}`
        );
      case 'Notification':
        return this.setDocumentTitle(
          `Notification · ${payload?.title || 'Details'}`
        );
      default:
        return this.setDocumentTitle(this.appName);
    }
  }

  private normalizeUrl(rawUrl: string): string {
    return rawUrl.split('?')[0].toLowerCase();
  }

  private resolveFallbackTitle(url: string): string {
    if (url.includes('/dashboard')) return 'Dashboard';
    if (url.includes('/notifications')) return 'Notifications';
    if (url.includes('/facilities')) return 'Facilities';
    if (url.includes('/invoices')) return 'Invoices';
    if (url.includes('/admins')) return 'Administrators';
    if (url.includes('/billable-rates')) return 'Billable Rates';
    if (url.includes('/billing')) return 'Billing Settings';
    if (url.includes('/profile')) return 'Profile';
    if (url.includes('/auth/login')) return 'Corporate portal · Sign in';
    if (url.includes('/auth/register')) return 'Corporate portal · Sign up';
    if (url.includes('/auth/terms-of-service'))
      return 'HURO · Terms of Service';

    // Add here any additional URL patterns specific to the corporate module if needed
    return 'HURO · Corporate portal';
  }

  private setDocumentTitle(pageTitle: string): void {
    this.title.setTitle(`${pageTitle}`);
  }
}
